export default __webpack_public_path__ + "static/media/add-tas.a0b37a2e.svg";